import { PROTOCOL_TEST_IDS } from '@/components/admin/protocoles/contracts';
import { Tooltip } from '@/components/ui/tooltip';

/**
 * The badge « adieu » of a farewell step (issue #163, §7.1; maquette
 * `adieu/etape-adieu.html`, `.bd.adieu`), on its frise card and on its node of
 * the tree.
 *
 * The only badge in bleu nuit FILLED: the others are tints that COUNT something
 * (attempts, exits, problems), and this one names what the step IS. It is also
 * the only badge a farewell-related fact gets - no « mène à l'adieu » on the
 * cards whose repli points here (H91): those read as any other jump, in the
 * lanes and in the tree.
 *
 * `aria-hidden` for the reason `step-card.tsx` gives for every badge: the card
 * is a `role="button"` named by its content. The fact stays reachable in words
 * where it is actionable - the box « Étape d'adieu » of the step's own panel.
 */
export function FarewellBadge() {
  return (
    <Tooltip label="étape d’adieu : un seul message, puis la page suivante">
      <span
        aria-hidden="true"
        data-testid={PROTOCOL_TEST_IDS.farewellBadge}
        className="inline-flex h-4 flex-none items-center rounded-pill bg-bleu-nuit px-1.5 font-semibold text-[10.5px] text-white tracking-wide"
      >
        adieu
      </span>
    </Tooltip>
  );
}
